import ViewBenchmark from "@views/ViewSimulator/views/ViewBenchmark";
import ViewNewScenario from "@views/ViewSimulator/views/ViewNewScenario";
import ViewScenario from "@views/ViewSimulator/views/ViewScenario";
import ViewScenarios from "@views/ViewSimulator/views/ViewScenarios";

export const ROUTING_HOME = "";
export const ROUTING_BENCHMARK = "/benchmark";
export const ROUTING_NEW_SIMULATION = "/new_scenario";
export const ROUTING_SIMULATION = "/scenario/:id";

const ROUTES = {
  HOME: ROUTING_HOME,
  BENCHMARK: ROUTING_BENCHMARK,
  NEW_SIMULATION: ROUTING_NEW_SIMULATION,
  SIMULATION: ROUTING_SIMULATION
};

export type SimulatorRouteConfig = {
  path: string;
  component: () => JSX.Element;
};

export const SimulatorModulesConfig: { [key: string]: SimulatorRouteConfig } = {
  [ROUTING_HOME]: {
    path: ROUTES.HOME,
    component: ViewScenarios
  },
  [ROUTING_BENCHMARK]: {
    path: ROUTES.BENCHMARK,
    component: ViewBenchmark
  },
  [ROUTING_NEW_SIMULATION]: {
    path: ROUTES.NEW_SIMULATION,
    component: ViewNewScenario
  },
  [ROUTING_SIMULATION]: {
    path: ROUTES.SIMULATION,
    component: ViewScenario
  }
};
